import React, { Component } from 'react';
import { connect } from 'shalala';
import { Guardian } from '@xaamin/guardian';
import { Dropdown, ButtonGroup } from 'react-bootstrap';

import { Http } from '../../../../support';
import { useStore } from '../../../../store';
import LoadingButton from '../../../../facturotopia/LoadingButton';

class TimbradoSftpActions extends Component {

  state = {
    busy: false,
    sendXml: false,
    showConfirm: false
  }

  handleOnCancelActionClick = () => {
    this.setState({
      showConfirm: true
    });
  }

  handleOnDownloadActionClick = async () => {
    this.setState({
      busy: true
    });

    try {
      const params = {
        download: 1,
        ...this.props.filters,
        as: 'link'
      }

      const response = await Http.get(`${window.BONJOUR_URL}/api/timbrado-tickets`, { params });

      if (!!response.data) {
        window.location = response.data.link;
      }
    } catch (error) {
    } finally {
      this.setState({
        busy: false
      });
    }
  }

  handleOnSendToSftpActionClick = async () => {
    this.setState({
      sendXml: true
    });

    try {
      const params = {
        sender: 1,
        status: 1,
        ...this.props.filters,
      }

      const response = await Http.get(`${window.BONJOUR_URL}/api/timbrado-tickets`, { params });

      if (!!response) {
        this.renderResult(response);
      }
    } catch (error) {
    } finally {
      this.setState({
        sendXml: false
      });
    }
  }

  renderResult = async (result) => {
    if (!!result) {
      let total = result.data.enviados;

      window.ToastManager.show({
        variant: 'success',
        title: 'Se ha enviado xml al servidor sftp',
        message: total ? 'enviados: ' + total : 'enviados: 0'
      })
    }
  }

  handleOnAction = (action) => {
  }

  render() {
    const { alignRight } = this.props;
    const { busy, sendXml } = this.state;

    return (
      <>
        <Dropdown as={ ButtonGroup } alignRight={ alignRight }>
          { Guardian.allows('timbrado.sftp.descargar.archivos.procesados') && (
            <LoadingButton
              variant="secondary"
              loading={ busy }
              onClick={ this.handleOnDownloadActionClick }
            >
              { busy === true ? 'Descargando' : 'Descargar' }
            </LoadingButton>
          )}

          { Guardian.allows('timbrado.sftp.reenviar.xml') && (
            <LoadingButton
              variant="secondary"
              loading={ sendXml }
              onClick={ this.handleOnSendToSftpActionClick }
            >
              { busy === true ? 'Enviando' : 'Enviar xml a sftp' }
            </LoadingButton>
          )}

          {/* <Dropdown.Toggle split variant="secondary" id="dropdown-split-basic" />

          <Dropdown.Menu>
            <Dropdown.Item as="div" onClick={ this.handleOnDownloadActionClick.bind(this, 'zip') }>Cancelar procesamiento</Dropdown.Item>
          </Dropdown.Menu> */}
        </Dropdown>
      </>

    )
  }
}

const mapState = (state) => {
  return state.modulo.timbrado_sftp.list;
}

const mapActions = (actions) => {
  return {};
}

export default connect(useStore, mapState, mapActions)(TimbradoSftpActions);